<div class="card-header w-100 d-flex flex-row justify-content-between">
    <h2>Expenses</h2>

    <a *ngIf="(reportLoading || (!reportLoading && rows.length)) && hasReadAccess" class="btn btn-outline-secondary" routerLink="/app/transactions">
        <img src="/assets/images/payhoa/other/pencil.svg"/>
        Transactions
    </a>

</div>
<div class="card-body pt-3">

    <!-- Filters -->
    <div class="d-flex justify-content-start">
        <report-filter-single-date-range-simple [doMatSelect]="true"
                                                [filterOnChange]="true"
                                                (filterReady)="filtersLoaded($event)"
                                                (filterResults)="getReport($event)"></report-filter-single-date-range-simple>
    </div>

    <!-- loading -->
    <div *ngIf="reportLoading" class="d-loading">
        <div class="loader">Loading...</div>
    </div>

    <!-- shows if no values -->
    <div *ngIf="!reportLoading && chartTotal == 0">
        <div class="circle-graph-container">
            <div class="graph-data">
                <strong>$0.00</strong>
                <div>Expenses</div>
            </div>
            <svg class="circle-graph expenses-graph" version="1.1" viewport="0 0 100 100"
                 xmlns="http://www.w3.org/2000/svg">
                <!--suppress HtmlUnknownAttribute -->
                <circle cx="75" cy="75" fill="transparent" r="70" stroke="#dcdcdc"
                        stroke-dasharray="440" stroke-dashoffset="0"></circle>

            </svg>
        </div>
    </div>


    <div *ngIf="!reportLoading && chartTotal !== 0">
        <!-- graph -->
        <div [routerLink]="['/app/reports/expenses/by-category', { startDate: filters.startDate.format('X'), endDate: filters.endDate.format('X') }]"
             class="circle-graph-container add-hover">
            <div class="graph-data">
                <strong>{{chartTotal | legfiCurrency : 'USD' : 'symbol' : '.2'}}</strong>
                <div>Expenses</div>
            </div>
            <svg class="circle-graph expenses-graph" version="1.1" viewport="0 0 100 100"
                 xmlns="http://www.w3.org/2000/svg">
                <circle class="stroke-other" cx="75" cy="75" fill="transparent" r="70"
                        stroke-dasharray="440" stroke-dashoffset="0"></circle>

                <!--suppress HtmlUnknownAttribute -->
                <circle *ngIf="catThree" [attr.stroke-dashoffset]="catThree.offset" class="stroke-three" cx="75" cy="75" fill="transparent"
                        r="70"
                        stroke-dasharray="440" stroke-linecap="round"></circle>

                <!--suppress HtmlUnknownAttribute -->
                <circle *ngIf="catTwo" [attr.stroke-dashoffset]="catTwo.offset" class="stroke-two" cx="75" cy="75" fill="transparent"
                        r="70"
                        stroke-dasharray="440" stroke-linecap="round"></circle>

                <!--suppress HtmlUnknownAttribute -->
                <circle *ngIf="catOne" [attr.stroke-dashoffset]="catOne.offset" class="stroke-one" cx="75" cy="75" fill="transparent"
                        r="70"
                        stroke-dasharray="440" stroke-linecap="round"></circle>

            </svg>
        </div>

        <div *ngIf="catOne"
             [routerLink]="['/app/reports/expenses/by-category', { startDate: filters.startDate.format('X'), endDate: filters.endDate.format('X') }]"
             class="mb-1 d-flex w-100 justify-content-between">
            <div class="add-hover"><span class="legend-circle cat-one"></span>
                {{catOne.category}}   </div>
            {{catOne.amount | legfiCurrency : 'USD' : 'symbol' : '.2'}}
        </div>
        <div *ngIf="catTwo"
             [routerLink]="['/app/reports/expenses/by-category', { startDate: filters.startDate.format('X'), endDate: filters.endDate.format('X') }]"
             class="mb-1 d-flex w-100 justify-content-between">
            <div class="add-hover"><span class="legend-circle cat-two"></span>
                {{catTwo.category}}  </div>
            {{catTwo.amount | legfiCurrency : 'USD' : 'symbol' : '.2'}}
        </div>
        <div *ngIf="catThree"
             [routerLink]="['/app/reports/expenses/by-category', { startDate: filters.startDate.format('X'), endDate: filters.endDate.format('X') }]"
             class="mb-1 d-flex w-100 justify-content-between">
            <div class="add-hover"><span class="legend-circle cat-three"></span>
                {{catThree.category}}  </div>
            {{catThree.amount | legfiCurrency : 'USD' : 'symbol' : '.2'}}
        </div>
        <div [routerLink]="['/app/reports/expenses/by-category', { startDate: filters.startDate.format('X'), endDate: filters.endDate.format('X') }]"
             class="d-flex w-100 justify-content-between">
            <div class="add-hover"><span class="legend-circle cat-other"></span>
                Other categories
            </div>
            <span>{{ chartOtherTotal |  legfiCurrency : 'USD' : 'symbol' : '.2' }}</span>
        </div>
    </div>

</div>
